<div class="n-profissionais-layout">
  <div class="n-container-orientacoes">
    <h4 class="n-titulo-orientacao">{{ 'PRIMEIRO_ACESSO.PROFISSIONAIS.ORIENTACAO_TITULO' | translate }}</h4>
    <p>{{ 'PRIMEIRO_ACESSO.PROFISSIONAIS.ORIENTACAO_TEXTO' | translate }}</p>
  </div>

  <!-- Formulário de Profissional -->
  <div class="n-profissional-form">
    <form [formGroup]="form" class="profissional-form">
      <div class="n-form-section">
        <h4 class="n-section-title">{{ 'PRIMEIRO_ACESSO.PROFISSIONAIS.NOVO_PROFISSIONAL' | translate }}</h4>

        <div class="n-field-group">
          <div class="n-field n-field-large">
            <lib-form-field
              [label]="'PRIMEIRO_ACESSO.PROFISSIONAIS.LABEL_NOME' | translate"
              controlName="nome"
              [required]="true"
              [helpText]="'PRIMEIRO_ACESSO.PROFISSIONAIS.HINT_NOME' | translate"
              [maxLength]="50"
            >
              <input
                pInputText
                id="nome"
                formControlName="nome"
                [placeholder]="'PRIMEIRO_ACESSO.PROFISSIONAIS.PLACEHOLDER_NOME' | translate"
                maxlength="50"
                class="w-full"
              />
            </lib-form-field>
          </div>

          <div class="n-field n-field-large">
            <lib-form-field
              [label]="'PRIMEIRO_ACESSO.PROFISSIONAIS.LABEL_DESCRICAO' | translate"
              controlName="descricao"
              [maxLength]="100"
            >
              <input
                pInputText
                id="descricao"
                formControlName="descricao"
                [placeholder]="'PRIMEIRO_ACESSO.PROFISSIONAIS.PLACEHOLDER_DESCRICAO' | translate"
                maxlength="100"
                class="w-full"
              />
            </lib-form-field>
          </div>

          <div class="n-field n-field-large">
            <lib-form-field
              [label]="'PRIMEIRO_ACESSO.PROFISSIONAIS.LABEL_PERFIL' | translate"
              controlName="perfilAcesso"
              [required]="true"
            >
              @if (deviceService.$isMobile()) {
              <lib-n-multiselect
                [multiple]="false"
                formControlName="perfilAcesso"
                [options]="perfisAcesso"
                optionLabel="label"
                optionValue="value"
                [placeholder]="'PRIMEIRO_ACESSO.PROFISSIONAIS.PLACEHOLDER_PERFIL' | translate"
              />
              } @else {
              <p-select
                id="perfilAcesso"
                formControlName="perfilAcesso"
                [options]="perfisAcesso"
                optionLabel="label"
                optionValue="value"
                [placeholder]="'PRIMEIRO_ACESSO.PROFISSIONAIS.PLACEHOLDER_PERFIL' | translate"
                [style]="{ width: '100%' }"
              />
              }
            </lib-form-field>
          </div>

          <div class="n-field n-field-large">
            <lib-form-field
              [label]="'PRIMEIRO_ACESSO.PROFISSIONAIS.LABEL_PRESTA_ATENDIMENTO' | translate"
              controlName="prestaAtendimento"
              [helpText]="'PRIMEIRO_ACESSO.PROFISSIONAIS.HELP_PRESTA_ATENDIMENTO' | translate"
            >
              <p-togglebutton
                formControlName="prestaAtendimento"
                [onLabel]="'GLOBAL.SIM' | translate"
                [offLabel]="'GLOBAL.NAO' | translate"
                [offIcon]="'pi pi-times'"
                [onIcon]="'pi pi-check'"
                styleClass="w-full"
              />
            </lib-form-field>
          </div>
        </div>

        <div class="n-field-group">
          <div class="n-field">
            <lib-form-field
              [label]="'PRIMEIRO_ACESSO.PROFISSIONAIS.LABEL_DIAS_TRABALHO' | translate"
              controlName="diasSelecionados"
              [required]="$expedienteObrigatorio()"
              [helpText]="$expedienteHelpText()"
            >
              @if (deviceService.$isMobile()) {
              <lib-n-multiselect
                formControlName="diasSelecionados"
                [options]="diasSemanaOptions"
                optionLabel="label"
                optionValue="id"
                [placeholder]="'PRIMEIRO_ACESSO.PROFISSIONAIS.PLACEHOLDER_DIAS_TRABALHO' | translate"
                [maxSelectedLabels]="3"
                [selectedItemsLabel]="'PRIMEIRO_ACESSO.PROFISSIONAIS.ITENS_SELECIONADOS' | translate"
                [showHeader]="false"
              />
              } @else {
              <p-multiSelect
                id="diasSelecionados"
                formControlName="diasSelecionados"
                [options]="diasSemanaOptions"
                optionLabel="label"
                optionValue="id"
                [placeholder]="'PRIMEIRO_ACESSO.PROFISSIONAIS.PLACEHOLDER_DIAS_TRABALHO' | translate"
                [maxSelectedLabels]="3"
                [selectedItemsLabel]="'PRIMEIRO_ACESSO.PROFISSIONAIS.ITENS_SELECIONADOS' | translate"
                [style]="{ width: '100%' }"
                appendTo="body"
              />
              }
            </lib-form-field>
          </div>

          <div class="n-field">
            <lib-form-field
              [label]="'PRIMEIRO_ACESSO.PROFISSIONAIS.LABEL_SERVICOS' | translate"
              controlName="servicosSelecionados"
              [required]="$servicosObrigatorios()"
              [helpText]="$servicosHelpText()"
            >
              @if (deviceService.$isMobile()) {
              <lib-n-multiselect
                formControlName="servicosSelecionados"
                [options]="$servicos()"
                optionLabel="nome"
                optionValue="id"
                [placeholder]="'PRIMEIRO_ACESSO.PROFISSIONAIS.PLACEHOLDER_SERVICOS' | translate"
                [maxSelectedLabels]="2"
                [selectedItemsLabel]="'PRIMEIRO_ACESSO.PROFISSIONAIS.ITENS_SELECIONADOS' | translate"
                [showHeader]="true"
              />
              } @else {
              <p-multiSelect
                id="servicosSelecionados"
                formControlName="servicosSelecionados"
                [options]="$servicos()"
                optionLabel="nome"
                optionValue="id"
                [placeholder]="'PRIMEIRO_ACESSO.PROFISSIONAIS.PLACEHOLDER_SERVICOS' | translate"
                [maxSelectedLabels]="2"
                [selectedItemsLabel]="'PRIMEIRO_ACESSO.PROFISSIONAIS.ITENS_SELECIONADOS' | translate"
                [style]="{ width: '100%' }"
                appendTo="body"
              />
              }
            </lib-form-field>
          </div>
        </div>

        <div class="n-field-group">
          <div class="n-field">
            <lib-form-field
              [label]="'PRIMEIRO_ACESSO.PROFISSIONAIS.LABEL_INICIO_EXPEDIENTE' | translate"
              controlName="inicioExpediente"
              [required]="$expedienteObrigatorio()"
            >
              @if (deviceService.$isMobile()) {
              <lib-n-multiselect
                [multiple]="false"
                id="inicioExpediente"
                formControlName="inicioExpediente"
                [options]="horariosInicio"
                optionLabel="label"
                optionValue="value"
                [placeholder]="'PRIMEIRO_ACESSO.PROFISSIONAIS.PLACEHOLDER_HORARIO' | translate"
              />
              } @else {
              <p-select
                id="inicioExpediente"
                formControlName="inicioExpediente"
                [options]="horariosInicio"
                optionLabel="label"
                optionValue="value"
                [placeholder]="'PRIMEIRO_ACESSO.PROFISSIONAIS.PLACEHOLDER_HORARIO' | translate"
                [style]="{ width: '100%' }"
              />
              }
            </lib-form-field>
          </div>

          <div class="n-field">
            <lib-form-field
              [label]="'PRIMEIRO_ACESSO.PROFISSIONAIS.LABEL_FIM_EXPEDIENTE' | translate"
              controlName="fimExpediente"
              [required]="$expedienteObrigatorio()"
            >
              @if (deviceService.$isMobile()) {
              <lib-n-multiselect
                [multiple]="false"
                id="fimExpediente"
                formControlName="fimExpediente"
                [options]="horariosFim"
                optionLabel="label"
                optionValue="value"
                [placeholder]="'PRIMEIRO_ACESSO.PROFISSIONAIS.PLACEHOLDER_HORARIO' | translate"
              />
              } @else {
              <p-select
                id="fimExpediente"
                formControlName="fimExpediente"
                [options]="horariosFim"
                optionLabel="label"
                optionValue="value"
                [placeholder]="'PRIMEIRO_ACESSO.PROFISSIONAIS.PLACEHOLDER_HORARIO' | translate"
                [style]="{ width: '100%' }"
              />
              }
            </lib-form-field>
          </div>
        </div>

        <div class="n-field-group">
          <div class="n-field">
            <lib-form-field [label]="'PRIMEIRO_ACESSO.PROFISSIONAIS.LABEL_INICIO_ALMOCO' | translate" controlName="almocoInicio">
              @if (deviceService.$isMobile()) {
              <lib-n-multiselect
                [multiple]="false"
                id="almocoInicio"
                formControlName="almocoInicio"
                [options]="horariosAlmocoInicio"
                optionLabel="label"
                optionValue="value"
                [placeholder]="'PRIMEIRO_ACESSO.PROFISSIONAIS.PLACEHOLDER_HORARIO' | translate"
              />
              } @else {
              <p-select
                id="almocoInicio"
                formControlName="almocoInicio"
                [options]="horariosAlmocoInicio"
                optionLabel="label"
                optionValue="value"
                [placeholder]="'PRIMEIRO_ACESSO.PROFISSIONAIS.PLACEHOLDER_HORARIO' | translate"
                [style]="{ width: '100%' }"
              />
              }
            </lib-form-field>
          </div>

          <div class="n-field">
            <lib-form-field [label]="'PRIMEIRO_ACESSO.PROFISSIONAIS.LABEL_FIM_ALMOCO' | translate" controlName="almocoFim">
              @if (deviceService.$isMobile()) {
              <lib-n-multiselect
                [multiple]="false"
                id="almocoFim"
                formControlName="almocoFim"
                [options]="horariosAlmocoFim"
                optionLabel="label"
                optionValue="value"
                [placeholder]="'PRIMEIRO_ACESSO.PROFISSIONAIS.PLACEHOLDER_HORARIO' | translate"
              />
              } @else {
              <p-select
                id="almocoFim"
                formControlName="almocoFim"
                [options]="horariosAlmocoFim"
                optionLabel="label"
                optionValue="value"
                [placeholder]="'PRIMEIRO_ACESSO.PROFISSIONAIS.PLACEHOLDER_HORARIO' | translate"
                [style]="{ width: '100%' }"
              />
              }
            </lib-form-field>
          </div>
        </div>

        <div class="n-add-action">
          @if ($atingiuLimiteProfissionais()) {
            <p class="text-color-secondary text-sm mb-2">
              {{ $mensagemLimiteProfissionais() }}
            </p>
          }
          <p-button
            [label]="'PRIMEIRO_ACESSO.PROFISSIONAIS.BOTAO_ADICIONAR' | translate"
            icon="pi pi-plus"
            [disabled]="form.invalid || $atingiuLimiteProfissionais()"
            (onClick)="adicionarProfissional()"
            type="button"
            [fluid]="true"
          />
        </div>
      </div>
    </form>
  </div>

  <!-- Lista de Profissionais -->
  @if (profissionaisSignal().length > 0) {
  <div class="n-profissionais-lista">
    <h4 class="n-section-title">{{ 'PRIMEIRO_ACESSO.PROFISSIONAIS.PROFISSIONAIS_CADASTRADOS' | translate }}</h4>
    <div class="n-profissionais-cards">
      @for (profissional of profissionaisSignal(); track $index) {
      <div class="n-profissional-card">
        <div class="n-profissional-info">
          <h5>{{ profissional.nome }}</h5>
          @if (profissional.descricao) {
          <p class="n-profissional-desc">{{ profissional.descricao }}</p>
          } @if (profissional.inicioExpediente && profissional.fimExpediente) {
          <div class="n-profissional-details">
            <small
              >⏰ {{ profissional.inicioExpediente }} -
              {{ profissional.fimExpediente }}</small
            >
          </div>
          }
        </div>
        <button
          pButton
          type="button"
          icon="pi pi-trash"
          severity="danger"
          (click)="removerProfissional($index)"
          class="n-remove-btn p-button-sm"
          [attr.aria-label]="'PRIMEIRO_ACESSO.PROFISSIONAIS.REMOVER_ARIA' | translate"
        ></button>
      </div>
      }
    </div>
  </div>
  }
</div>

<!-- Footer de Navegação -->
<ng-template #headerTemplate>
  <div class="w-full">
    <div
      class="pr-1 pl-1 pb-2 pt-2 border-round-lg lg:col-12 n-header-gradient"
    >
      <div class="n-header-content">
        <div class="sm:col-12 md:col-8">
          <span class="n-header-title text-white font-bold">
            <i class="pi pi-users mr-2"></i>
            {{ 'PRIMEIRO_ACESSO.PROFISSIONAIS.HEADER_TITULO' | translate }}
          </span>
        </div>
        <div class="sm:col-12 md:col-4 flex justify-content-end gap-2">
          @if (!deviceService.$isMobile()) {
          <button
            type="button"
            class="n-close-btn"
            (click)="fechar.emit()"
            [attr.aria-label]="'GLOBAL.FECHAR' | translate"
          >
            <i class="pi pi-times"></i>
          </button>
          }
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="flex gap-2 justify-content-end w-full">
    <p-button
      [label]="'GLOBAL.VOLTAR' | translate"
      icon="pi pi-arrow-left"
      severity="secondary"
      [outlined]="true"
      (onClick)="voltar()"
      type="button"
    />
    <p-button
      [label]="'GLOBAL.PROXIMO' | translate"
      icon="pi pi-arrow-right"
      styleClass="p-button-primary"
      iconPos="right"
      [loading]="$loading()"
      [disabled]="profissionaisSignal().length === 0 || $loading()"
      (onClick)="salvar()"
      type="button"
    />
  </div>
</ng-template>
